import React from "react";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import MtechSelfSponsored_admissionEle from "./MtechSelfSponsored_admissionEle";

function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Admission" />
            <MtechSelfSponsored_admissionEle />
        </>
    );
}

export default Main;
